var _g, _path, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatsappIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 78,
    viewBox: "0 0 78 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_63_92)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 38.9054,
    cy: 38.9054,
    r: 38.9054,
    fill: "#485823"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_63_92",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 23,
    y: 23,
    width: 33,
    height: 33
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.2871 23H55.4768V55.5361H23.2871V23Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_63_92)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.4146 23.2406L41.4489 23.1036C38.5466 22.6801 35.585 23.0991 32.9093 24.3119C30.2337 25.5246 27.9542 27.4812 26.3367 29.9534C24.6156 32.3165 23.5897 35.1227 23.3769 38.0492C23.1641 40.9756 23.7731 43.9033 25.1338 46.4954C25.273 46.7552 25.3597 47.0404 25.3888 47.3344C25.4179 47.6284 25.3888 47.9253 25.3032 48.2078C24.6086 50.6224 23.9648 53.054 23.2871 55.6055L24.1342 55.3487C26.4214 54.7322 28.7085 54.1157 30.9957 53.5506C31.4784 53.4492 31.9802 53.4969 32.4358 53.6876C34.4878 54.6999 36.7302 55.2567 39.0127 55.3209C41.2952 55.3851 43.5648 54.955 45.6693 54.0596C47.7738 53.1642 49.6644 51.8241 51.2144 50.1294C52.7643 48.4346 53.9377 46.4244 54.6557 44.2335C55.3737 42.0427 55.6198 39.722 55.3775 37.4271C55.1351 35.1322 54.4099 32.9163 53.2505 30.928C52.0911 28.9397 50.5244 27.2251 48.6555 25.8992C46.7865 24.5733 44.6586 23.6669 42.4146 23.2406ZM46.6839 45.7077C46.0682 46.2649 45.3173 46.6472 44.5078 46.8157C43.6983 46.9841 42.8591 46.9327 42.0757 46.6667C38.5256 45.6563 35.4457 43.4049 33.3845 40.3135C32.5972 39.2202 31.9643 38.0214 31.5039 36.7517C31.2547 36.015 31.2097 35.2233 31.374 34.4626C31.5382 33.7019 31.9054 33.0011 32.4358 32.4364C32.6939 32.1033 33.0453 31.8566 33.4442 31.7283C33.8431 31.6 34.271 31.5961 34.6721 31.7172C35.0109 31.8028 35.2481 32.2994 35.5531 32.6761C35.8004 33.3834 36.0901 34.0752 36.4171 34.7482C36.6652 35.0915 36.7688 35.5201 36.7053 35.9404C36.6418 36.3607 36.4164 36.7385 36.0783 36.9914C35.3159 37.6764 35.4345 38.2415 35.9766 39.0121C37.1752 40.7573 38.829 42.1325 40.7542 42.9849C41.2964 43.2247 41.703 43.276 42.0588 42.7109C42.2113 42.4883 42.4146 42.3 42.584 42.0945C43.5666 40.8444 43.2617 40.8615 44.8203 41.5465C45.3167 41.7571 45.7979 42.0037 46.2604 42.2828C46.7178 42.5568 47.4124 42.8479 47.5141 43.2589C47.6119 43.7048 47.5861 44.1693 47.4397 44.6013C47.2932 45.0333 47.0317 45.4162 46.6839 45.7077Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_63_92",
    x: -38,
    y: -38,
    width: 153.811,
    height: 153.811,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 19
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_63_92"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_63_92",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsappIcon);
export default __webpack_public_path__ + "static/media/whatsapp-icon.373a0ae04da575f3214c8c9023a5d5a3.svg";
export { ForwardRef as ReactComponent };